import React, { useState } from 'react';
import { useSpecialistAuth } from '../../context/SpecialistAuthContext';
import SpecialistDashboardLayout from '../../components/SpecialistDashboardLayout';

const SpecialistMessagesPage = () => {
  const { specialist } = useSpecialistAuth();
  const [messages, setMessages] = useState([]);

  return (
    <SpecialistDashboardLayout>
      <div className="specialist-messages-content" style={{ padding: '0' }}>
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ fontSize: '24px', fontWeight: '600', color: '#1F396C', margin: '0 0 8px 0' }}>Inquiries & Messages</h1>
          <p style={{ fontSize: '14px', color: '#6D6D6D', margin: 0 }}>Manage all your inquiries and messages in one place.</p>
        </div>

        <div style={{ display: 'flex', gap: '16px', height: 'calc(100vh - 280px)', minHeight: '400px' }}>
          {/* Messages List */}
          <div style={{ 
            width: '340px', 
            background: '#fff', 
            borderRadius: '12px', 
            border: '1px solid #eee',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <div style={{ padding: '16px', borderBottom: '1px solid #eee' }}>
              <input 
                type="text" 
                placeholder="Search messages..." 
                style={{ 
                  width: '100%', 
                  padding: '10px 16px', 
                  border: '1px solid #ddd', 
                  borderRadius: '8px', 
                  fontSize: '14px',
                  boxSizing: 'border-box'
                }}
              />
            </div>
            <div style={{ flex: 1, overflowY: 'auto', padding: '8px' }}>
              {messages.length === 0 ? (
                <div style={{ padding: '40px 20px', textAlign: 'center', color: '#999' }}>
                  <p style={{ margin: '0 0 4px 0', fontWeight: '500', color: '#666', fontSize: '14px' }}>No messages yet</p>
                  <p style={{ margin: 0, fontSize: '13px' }}>Your inquiries will appear here</p>
                </div>
              ) : null}
            </div>
          </div>

          {/* Message Detail */}
          <div style={{ 
            flex: 1, 
            background: '#fff', 
            borderRadius: '12px', 
            border: '1px solid #eee',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div style={{ textAlign: 'center', color: '#999' }}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" style={{ marginBottom: '12px', opacity: 0.3 }}>
                <path d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z" stroke="#ccc" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <p style={{ margin: '0 0 4px 0', fontWeight: '500', color: '#666', fontSize: '15px' }}>Select a conversation</p>
              <p style={{ margin: 0, fontSize: '13px' }}>Choose a message from the list to view details</p>
            </div>
          </div>
        </div>
      </div>
    </SpecialistDashboardLayout>
  );
};

export default SpecialistMessagesPage;
